/* eslint-disable no-unused-vars */
/**
 * @enum
 */

export enum ButtonType {
  PRIMARY = "btn-primary",
  SECONDARY = "btn-secondary",
  DISABLED = "btn-disabled",
  DELETE = "btn-danger",
}

export enum HeadingType {
  MAIN = "text-2xl text-primary-blackMain font-semibold",
  SUB = "text-lg text-primary-blackMain font-semibold",
  SUBSUB = "text-base text-primary-blackMain font-semibold",
}

export enum TextInputType {
  NUMBER = "number",
  TEXT = "text",
  PASSWORD = "password",
  EMAIL = "email",
  DATE = "date",
}

export enum SupportedLocale {
  EN_US = "en-US",
  EN_GB = "en-GB",
  FR_FR = "fr-FR",
  DE_DE = "de-DE",
  ES_ES = "es-ES",
  IT_IT = "it-IT",
  PT_PT = "pt-PT",
  AR_SA = "ar-SA",
  SW_KE = "sw-KE",
  EN_NG = "en-NG",
}
